import { useMemo } from "react";
import { calculateMiddleMilePricing, DEFAULT_MIDDLEMILE_PRICING_CONFIG, } from "../services/pricing.js";
export function useMiddleMilePricing(input) {
    return useMemo(() => {
        const config = input.config || DEFAULT_MIDDLEMILE_PRICING_CONFIG;
        return calculateMiddleMilePricing({ ...input, config });
    }, [input.distanceMiles, input.weightKg, input.palletCount, input.isOvernight, input.config, input.minimums]);
}
//# sourceMappingURL=useMiddleMilePricing.js.map